<template>
<div class="dropdownCheck" :style="full_width ? 'width:100%' : ''">
    <div class="dropdownCheckSelected" :class="{'dropdownCheckDisabled': empty}" @click="toggleDropdown">
        <div class="dropdownCheckText">{{checked_names}}</div>
        <div class="dropdownCheckToggle">
            <i class="fas fa-angle-down" v-show="closed" />
            <i class="fas fa-angle-up" v-show="!closed" />
        </div>
    </div>
    <div class="dropdownCheckPopup" v-show="!closed">
        <div v-for="(item, index) in items" :key="item[id_str]" :style="hover[index] ? 'background-color: #f1f1f1;' : ''">
            <div class="dropdownCheckItem" @mouseover="onMouseOver(index)" @mouseleave="onMouseLeave(index)"
                @click="nested ? checkParent(item[id_str]) : check(item[id_str])">
                <div class="dropboxCheckButton" />
                <input type="checkbox" @change="check(item[id_str])" :checked="value.includes(item[id_str])" v-if="!nested" />
                <label for="checkbox" v-if="!nested">{{item[label_str]}}</label>
                <div class="dropdownCheckParent" v-if="nested">{{item[label_str]}}</div>
            </div>
            <div v-if="nested">
                <div class="dropdownCheckItem" v-for="child in item.children" :key="child[id_str]" @click="check(child[id_str])">
                    <div class="dropboxCheckButton" />
                    <input type="checkbox" @change="check(child[id_str])" :checked="value.includes(child[id_str])" />
                    <label for="checkbox">{{child[label_str]}}</label>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'DropdownCheck',
    props: {
        items: Array,
        value: Array,
        full_width: Boolean,
        id_str: {
            type: String,
            default: 'id'
        },
        label_str: {
            type: String,
            default: 'label'
        },
        allow_none: {
            type: Boolean,
            default: false
        },
        check_all: {
            type: Boolean,
            default: true
        },
        dropdown_group: {
            required: false,
            default: false
        },
        nested: {
            type: Boolean,
            default: false
        },
        multiselect: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        checked_names() {
            let filtered, total_length;
            if (this.nested) {
                const flattened_list = this.items.map(i => i.children).flat()
                filtered = flattened_list.filter(i => this.value.includes(i[this.id_str]))
                total_length = flattened_list.length
            }
            else {
                filtered = this.items.filter(i => this.value.includes(i[this.id_str]))
                total_length = this.items.length
            }
            if (filtered.length === 0) return "Vælg..."
            else if (filtered.length == total_length && total_length > 2) return 'Alle'
            else if (filtered.length == 1) return filtered[0][this.label_str]
            else return filtered.length + ' valgt'
        },
        empty() {
            return this.items.length === 0
        }
    },
    watch: {
        items() {
            if (this.check_all) this.items.forEach(x => this.check(x[this.id_str]))
        }
    },
    data() {
        return {
            closed: true,
            hover: new Array(this.items.length).fill(false)
        }
    },
    created() {
        document.addEventListener('click', this.checkClick)
    },
    destroyed() {
        // important to clean up!!
        document.removeEventListener('click', this.checkClick)
    },
    methods: {
        onMouseOver(index) { 
            Vue.set(this.hover, index, true)
        },
        onMouseLeave(index) { 
            Vue.set(this.hover, index, false)
        },
        toggleDropdown() {
            if (!this.empty) {
                // Let parent close all other dropdown groups
                if (this.dropdown_group !== false && this.closed) this.$emit("toggleDropdown", this.dropdown_group)
                this.closed = !this.closed
            }
        },
        checkParent(id) {
            if (!this.multiselect) return
            const parent = this.items.find(g => g.id == id)
            const children = parent.children.map(u => u.id)
            const checked = children.some(u => this.value.includes(u))
            if (checked)
                this.$emit('input', this.value.filter(v => !children.includes(v)))
            else
                this.$emit('input', [...new Set([...this.value, ...children])])
        },
        check(id) {
            const checked = this.value
            const index = this.value.findIndex(cid => cid == id)
            if (index == -1) checked.push(id)
            else if (!this.allow_none && this.value.length == 1) return
            else checked.splice(index, 1)
            if (!this.multiselect && this.value.length == 2) this.check(this.value[0])
            this.$emit('input', checked)
        },
        checkClick(e) {
            if (e.path && !e.path.find(el => el.className == 'dropdownCheck')) {
                this.closed = true
            }
        },
        
    }
}
</script>

<style>

.dropdownCheckParent {
    font-weight: bold;
}

.dropdownCheck {
    min-width: 8em;
    position: relative;
}

.dropdownCheckDisabled {
    color:gray
}

.dropdownCheckSelected {
    background-color: #f1f2f2;
    border: 1px solid #f9f9f9;
    padding: 0.2em;
    display: flex;
    position: relative;
}

.dropdownCheckSelected:hover {
    cursor: pointer;
}

.dropdownCheckText {
    margin-left: 0.1em;
}

.dropdownCheckToggle {
    margin-left: auto;
    margin-right: 0.1em;
}

.dropdownCheckPopup {
    padding: 0.2em;
    box-shadow: 0px 0px 20px #e2e2e2;
    position: absolute;
    width: 100%;
    max-height: 9em;
    background-color: white;
    z-index: 1;
    overflow: auto;
}

.dropdownCheckItem {
    padding: 0.2em;
    display: flex;
    position: relative;
}

.dropdownCheckItem:hover {
    background-color: #f1f1f1;
    border-radius: 2px;
    cursor: pointer;
}

.dropboxCheckButton {
    position: absolute;
    width: 100%;
    height: 90%;
} 

.dropdownCheckItem label {
    margin-top: auto;
    margin-left: 0.2em
}

</style>